export default __webpack_public_path__ + "img/arrow-circle-right.0d5303fa.png";